module.exports = __webpack_public_path__ + "img/woman-helmet.6ee1ca81.png";